import Vue from "vue"

export default {
  mutations: {
    RESET: function (state, initialState, ignoredKeys) {
      ignoredKeys = ignoredKeys || []

      for (let key in initialState) {
        if (!ignoredKeys.includes(key)) Vue.set(state, key, initialState[key])
      }
    },
  },
}
